<template>
  <button
    type="button"
    :class="[
      'transition-color block h-[1.5rem] w-[2.5rem] cursor-pointer rounded-full p-[0.125rem]',
      inputField ? 'bg-primary-500' : 'bg-gray-100',
      disabled ? 'cursor-default bg-gray-200' : '',
    ]"
    :disabled="disabled"
    @click="toggleSwitch"
  >
    <div
      class="h-[1.25rem] w-[1.25rem] rounded-full bg-white transition-transform"
      :style="{ transform: inputField ? 'translateX(calc(100% - 0.25rem))' : 'translateX(0)' }"
    />
  </button>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'SparkSwitch',

  props: {
    name: { type: String, required: true },
    modelValue: { type: Boolean, required: true },
    disabled: { type: Boolean },
  },

  emits: ['update:modelValue'],

  setup(props, { emit }) {
    const inputField = computed({
      get: () => props.modelValue,
      set: value => emit('update:modelValue', value),
    });

    const toggleSwitch = () => {
      if (!props.disabled) {
        emit('update:modelValue', !props.modelValue);
      }
    };

    return { inputField, toggleSwitch };
  },
};
</script>
